export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "App";

export const APP_LOGO =
  import.meta.env.VITE_APP_LOGO ||
  "https://placehold.co/128x128/E1E7EF/1F2937?text=App";

// Generate login URL for Google OAuth
export const getLoginUrl = () => {
  const apiUrl = import.meta.env.VITE_API_URL || window.location.origin;
  return `${apiUrl}/api/auth/google`;
};